import React from 'react'
import PropTypes from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import StarsRating from 'Pods/Shared/StarsRating'

function UserProjectsRatings({ rating }) {
  return (
    <div className="user-reviews__rating">
      <span className="message__rating-subtitle u-mr10">
        {i18n.t('avg_rating', { ns: 'profile' })}:
      </span>
      <span className="message__stars-rate">
        <StarsRating
          rating={rating}
          readonly
        />
      </span>
    </div>
  )
}

UserProjectsRatings.propTypes = {
  rating: PropTypes.number.isRequired,
}

export default UserProjectsRatings
